import { api } from "./api";

export const GET_ALL_BRANDS = async () => {
    const { data } = await api.get("/brands")
    return data.brands || [];
}

export const GET_BRAND = async (id: string) => {
    const { data } = await api.get(`/brands/${id}`)
    return data;
}

export const DELETE_BRAND = async (id: string) => {
    const { data } = await api.delete(`/brands/${id}`)
    return data;
}

export const CREATE_BRAND = async (params: any) => {
    const { data } = await api.post(`/brands`, params)
    return data;
}

export const UPDATE_BRAND = async (id: string, params: any) => {
    const { data } = await api.patch(`/brands/${id}`, params)
    return data;
}

